import { Controller } from "stimulus"


export default class extends Controller {
  static values = {
    time: Number
  }

  connect() {
    if (!this.hasTimeValue) return

    this.timer = setInterval(() => {
      this.element.style.opacity = 100;
    }, this.timeValue * 1000);
  }
}